/**
 * @generated SignedSource<<377a0c536b9aa2d856ce1f98d2010a61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type ChargePaymentStatus = "AUTO_CHARGE" | "CANCELED" | "FULLY_REFUNDED" | "MARKED_PAID" | "NO_CHARGES" | "PAID" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED" | "PROCESSING" | "UNKNOWN" | "UNPAID";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type ManualPaymentStatus = "AUTO_CHARGE" | "MARKED_PAID" | "PAYMENT_EXPECTED";
export type RequestRecurrenceEndCondition = "AFTER_OCCURRENCES" | "ON_DATE";
export type RequestRecurrenceType = "DAY" | "MONTH" | "WEEK";
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
import { FragmentRefs } from "relay-runtime";
export type useInitializeEditBookingModal_Booking$data = {
  readonly __typename: string;
  readonly bookingSeries: {
    readonly bookings: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly startSlot: {
            readonly agenda: {
              readonly date: string;
            };
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly effectiveEndDate: string | null | undefined;
    readonly endCondition: RequestRecurrenceEndCondition | null | undefined;
    readonly recurrenceType: RequestRecurrenceType | null | undefined;
    readonly repeatInterval: number | null | undefined;
    readonly requestedOccurrenceCount: number | null | undefined;
  } | null | undefined;
  readonly durationMins?: number | null | undefined;
  readonly id: string;
  readonly instructors?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly lessonType?: {
    readonly id: string;
  } | null | undefined;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly paymentStatus?: ChargePaymentStatus | null | undefined;
  readonly rate: {
    readonly id: string;
  } | null | undefined;
  readonly request?: {
    readonly bookingRule: {
      readonly maxRequestCount?: number;
    } | null | undefined;
    readonly maxTime: string;
    readonly minTime: string;
    readonly time: string;
  } | null | undefined;
  readonly rounds: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly bookedRate: {
          readonly appliesToMembershipType: boolean | null | undefined;
          readonly eighteenHolePrice: number | null | undefined;
          readonly nineHolePrice: number | null | undefined;
          readonly rate: {
            readonly dynamicEnabled?: boolean;
            readonly dynamicOverridden?: boolean;
            readonly id: string;
            readonly name: string;
            readonly visibility: VisibilityStatus;
          };
        } | null | undefined;
        readonly bookingIndex: number | null | undefined;
        readonly courseLayout: {
          readonly holeCount: HoleCount;
          readonly id: string;
        } | null | undefined;
        readonly host?: {
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly manualPaymentStatus: ManualPaymentStatus;
        readonly nonPlayingHost?: boolean;
        readonly paymentStatus: ChargePaymentStatus;
        readonly player: {
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly memberGroups?: ReadonlyArray<{
            readonly id: string;
          } | null | undefined> | null | undefined;
          readonly membershipType?: {
            readonly id: string;
          } | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly roundRate: {
          readonly appliesToMembershipType: boolean | null | undefined;
          readonly eighteenHolePrice: number | null | undefined;
          readonly nineHolePrice: number | null | undefined;
          readonly rate: {
            readonly dynamicEnabled?: boolean;
            readonly dynamicOverridden?: boolean;
            readonly id: string;
            readonly name: string;
            readonly visibility: VisibilityStatus;
          };
        } | null | undefined;
        readonly secondaryTransportationType: {
          readonly id: string;
        } | null | undefined;
        readonly transportationType: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly seriesCount?: number | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly copyOverrides: {
          readonly bookingPlayer: {
            readonly singular: string;
          } | null | undefined;
          readonly lessonPlayer: {
            readonly singular: string;
          } | null | undefined;
        };
        readonly memberHoldDeadlineHours: number | null | undefined;
        readonly memberHoldEnabled: boolean;
        readonly type: FacilityType;
      };
    };
    readonly bookingRates?: ReadonlyArray<{
      readonly rate: {
        readonly appliesToMembershipType: boolean | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly visibility: VisibilityStatus;
      };
    } | null | undefined> | null | undefined;
    readonly capacity?: number;
    readonly club: {
      readonly defaultCustomerType: {
        readonly id: string;
      } | null | undefined;
    };
    readonly course?: {
      readonly id: string;
    };
    readonly id: string;
    readonly time?: string;
    readonly usedCapacity?: number;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "useInitializeEditBookingModal_Booking";
};
export type useInitializeEditBookingModal_Booking$key = {
  readonly " $data"?: useInitializeEditBookingModal_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeEditBookingModal_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "singular",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v7 = [
  (v0/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "appliesToMembershipType",
    "storageKey": null
  },
  {
    "alias": "eighteenHolePrice",
    "args": [
      {
        "kind": "Literal",
        "name": "holeCount",
        "value": "EIGHTEEN"
      }
    ],
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
  },
  {
    "alias": "nineHolePrice",
    "args": [
      {
        "kind": "Literal",
        "name": "holeCount",
        "value": "NINE"
      }
    ],
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dynamicEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dynamicOverridden",
            "storageKey": null
          }
        ],
        "type": "CustomerRate",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookingRule",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxRequestCount",
              "storageKey": null
            }
          ],
          "type": "RequestRule",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "bookingType",
      "variableName": "bookingType"
    }
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "QueueSlot",
  "abstractKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "bookingType"
    },
    {
      "kind": "RootArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeEditBookingModal_Booking",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingSeries",
      "kind": "LinkedField",
      "name": "bookingSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recurrenceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "repeatInterval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCondition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectiveEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requestedOccurrenceCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 366
            },
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                {
                  "direction": "DESC",
                  "field": "DATE_TIME"
                }
              ]
            }
          ],
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "bookings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "startSlot",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Agenda",
                          "kind": "LinkedField",
                          "name": "agenda",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lessonPlayer",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "bookingPlayer",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberHoldEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberHoldDeadlineHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usedCapacity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "highestPrecedentOnly",
                  "value": false
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                },
                {
                  "kind": "Variable",
                  "name": "visibleToMembershipTypeId",
                  "variableName": "membershipTypeId"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "bookingRates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "membershipTypeId",
                          "variableName": "membershipTypeId"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "appliesToMembershipType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerType",
              "kind": "LinkedField",
              "name": "defaultCustomerType",
              "plural": false,
              "selections": (v7/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v7/*: any*/),
          "type": "Customer",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v7/*: any*/),
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "bookingIndex",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransportationType",
                  "kind": "LinkedField",
                  "name": "transportationType",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransportationType",
                  "kind": "LinkedField",
                  "name": "secondaryTransportationType",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "manualPaymentStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoundRate",
                  "kind": "LinkedField",
                  "name": "bookedRate",
                  "plural": false,
                  "selections": (v8/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoundRate",
                  "kind": "LinkedField",
                  "name": "roundRate",
                  "plural": false,
                  "selections": (v8/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayout",
                  "kind": "LinkedField",
                  "name": "courseLayout",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "holeCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CustomerType",
                          "kind": "LinkedField",
                          "name": "membershipType",
                          "plural": false,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "type": "Customer",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MembershipType",
                          "kind": "LinkedField",
                          "name": "membershipType",
                          "plural": false,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MemberGroup",
                          "kind": "LinkedField",
                          "name": "memberGroups",
                          "plural": true,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "type": "Member",
                      "abstractKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "profileImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v9/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "nonPlayingHost",
                      "storageKey": null
                    }
                  ],
                  "type": "MemberRound",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Member",
                      "kind": "LinkedField",
                      "name": "host",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "GuestRound",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v9/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Course",
                  "kind": "LinkedField",
                  "name": "course",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "TimeSlot",
              "abstractKey": null
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonType",
          "kind": "LinkedField",
          "name": "lessonType",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StaffProfileConnection",
          "kind": "LinkedField",
          "name": "instructors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StaffProfileEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StaffProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v14/*: any*/),
              "type": "TimeSlot",
              "abstractKey": null
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "fb6ef699012f4f3ea8b450f8cef8c2e4";

export default node;
